import { FC, InputHTMLAttributes } from "react"
import clsx from "clsx"

export interface TextInputProps extends InputHTMLAttributes<any> {
  errorText?: string
  inputClassName?: string
}

export const TextInput: FC<TextInputProps> = ({
  errorText,
  className,
  inputClassName,
  ...props
}) => {
  if (props.type === "tel") {
    return (
      <div className={clsx("relative", className ?? "")}>
        <div>
          <input
            type="tel"
            disabled
            value="+62"
            className="lg:text-base bg-white text-grey-97 absolute left-[18px] top-[7px] w-7 text-sm"
          />
          <input
            {...props}
            pattern="[0-9]*"
            className={clsx(
              inputClassName,
              "py-2 pl-14 pr-[18px]",
              "w-full border border-[rgba(58,53,65,0.23)] lg:text-base",
              "focus:outline-none focus:shadow-outline active:shadow-outline  text-sm",
              errorText && "border-red border"
            )}
          />
          <small className="text-red absolute -bottom-4 left-0">{errorText}</small>
        </div>
      </div>
    )
  }
  return (
    <div className={clsx("relative", className)}>
      <input
        {...props}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded-xl w-full",
          "focus:outline-none focus:shadow-outline",
          errorText && "border-red border"
        )}
      />
      <small className="text-red">{errorText}</small>
    </div>
  )
}
